/* eslint-disable */
export default {
  close: 'Sulje',
} as const;

// @key: @#@"close"@#@ @source: @#@"Close"@#@
